import { render, staticRenderFns } from "./NavBarAcademy.vue?vue&type=template&id=af72f826&scoped=true"
import script from "./NavBarAcademy.vue?vue&type=script&lang=js"
export * from "./NavBarAcademy.vue?vue&type=script&lang=js"
import style0 from "./NavBarAcademy.vue?vue&type=style&index=0&id=af72f826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af72f826",
  null
  
)

export default component.exports